<template>
  <section class="app-transporte">
    <v-container grid-list-xl>
      <v-layout
        row
        wrap
      >
        <v-flex
          lg12
          sm12
          xs12
        >
          <Transportadora />
        </v-flex>
        <v-flex
          lg3
          sm3
        >
          <Menu />
        </v-flex>
        <v-flex
          lg9
          sm9
        >
          <router-view />
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import Transportadora from "./layout/Transportadora";
import Menu from "./layout/Menu";

export default {
  components: {
    Transportadora,
    Menu
  }
};
</script>
